import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Card, CardBody, Spinner, Modal, ModalHeader, Button, ModalBody, ModalFooter, ButtonGroup, Table } from 'reactstrap';
import axios from 'axios';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import uuid from 'react-uuid';
import { FaFile,FaDownload} from 'react-icons/fa';
import "../ExternalOrganisation/ExternalOrganisation.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast, { Toaster } from 'react-hot-toast';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import { apiGet, apiPost } from "../Utilities/Hooks/apiWrapper";

const DataImport = () => {
    const [showDeleteItemPopup, setShowDeleteItemPopup] = useState(false); const [deleteItemId, setDeleteItemId] = useState(0);
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId")); const [uploadedVineyardData, setUploadedVineyardData] = useState([]);
    const [uploadedContactData, setUploadedContactData] = useState([]);

    useEffect(() => {
        
    }, []);

    const confirmDeleteItemPopup = async () => {
        const response = await apiGet(
            '/api/settings/DeleteFarm/', {
            params: { Id: deleteItemId, userId: userId }
        }
        );
    }

    const closeDeleteItemPopup = async () => {
        setShowDeleteItemPopup(false);
    }

    const [uploadDocumentNameVineyard, setUploadDocumentNameVineyard] = useState('');
    let inputDocumentFile = '';
    const handleBtnDocumentUploadClick = async (e) => {
        e.preventDefault();
        inputDocumentFile.click();
        return false;
    }
    const onSelectionChange = async (selected) => {
        setRSelected(selected);
        setUploadDocumentNameVineyard('');
        setVineYardFile(null);
        document.getElementById("fileUpload").value = null;
    }
    const [formDocumentErrors, setFormDocumentErrors] = useState({});
    const [vineYardFile, setVineYardFile] = useState(null);
    const handleDocumentChange = async (e) => {
        e.preventDefault();
        setFormDocumentErrors({});
        let reader = new FileReader();
        let file = e.target.files[0];
        const errors = {};
        if (file.type != 'text/csv') {
            errors.DocumentName = "Only csv files can upload!";
        }
        else {
            errors.DocumentName = "";
        }
        setFormDocumentErrors(errors);
        if (errors.DocumentName == "") {
            setUploadDocumentNameVineyard(file.name)
            setVineYardFile(e.target.files[0]);
        }
    }
    const [saving, setSaving] = useState('');
    const [savingVineyard, setSavingVineyard] = useState('');
    const [savingContact, setSavingContact] = useState('');
    const handleUploadVineyard = async (e) => {
        e.preventDefault();
        setFormDocumentErrors({});
        let reader = new FileReader();
        let file = vineYardFile;
        const errors = {};
        if (file.type != 'text/csv') {
            errors.DocumentName = "Only csv files can upload!";
        }
        else {
            errors.DocumentName = "";
        }
        setFormDocumentErrors(errors);
        if (errors.DocumentName == "") {
            setSaving(true);
            const formData = new FormData();
            if (rSelected == 1) {
                formData.append("Type", "VineyardImport");
            }
            else {
                formData.append("Type", "ContactImport");
            }
            formData.append("FileName", file.name);
            formData.append("File", file);
            const response = await apiPost(
                '/api/uploaddocument/UploadDocument/', formData,
                {
                    headers: { "Content-type": "multipart/form-data", "Type": rSelected == 1 ? "VineyardImport" : "ContactImport", "userId": userId, "FileName": file },
                    withCredentials: true
                });
            if (response.data != null) {
                setSaving(false);
                if (response.data.status) {
                    setUploadDocumentNameVineyard('');
                    setVineYardFile(null);
                    document.getElementById("fileUpload").value = null;
                    if (response.data.content.length > 0) {
                        toast.success("Successfully uploaded, verify the data and save it to the system!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                    }
                    else {
                        toast.success("Successfully uploaded & no data found in the file!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                    }
                    if (rSelected == 1) {
                        setUploadedVineyardData(response.data.content);
                    }
                    else {
                        setUploadedContactData(response.data.content);
                    }
                }
                else {
                    toast.error("Error while importing data", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                    setTimeout(() => {
                        window.location.reload(true);
                    }, 3000);
                }
            }
        }
        else {
            setSaving(false);
        }
    }
    const saveVineyardData = async (e) => {
        e.preventDefault();
        setSavingVineyard(true);
        let form = {
            VineyardData: uploadedVineyardData,
            UserId: userId
        }
        const response = await apiPost(
            '/api/settings/SaveImportVineyardData/', form,
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            setSavingVineyard(false);
            if (response.data.status) {
                toast.success("Successfully saved data!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setTimeout(() => {
                    window.location.reload(true);
                }, 3000);
            }
            else {
                toast.error("Error while saving data", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                setTimeout(() => {
                    window.location.reload(true);
                }, 3000);
            }
        }
    }
    const saveContactData = async (e) => {
        e.preventDefault();
        setSavingContact(true);
        let form = {
            ContactData: uploadedContactData,
            UserId: userId
        }
        const response = await apiPost(
            '/api/settings/SaveImportContactData/', form,
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            setSavingContact(false);
            if (response.data.status) {
                toast.success("Successfully saved data!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setTimeout(() => {
                    window.location.reload(true);
                }, 3000);
            }
            else {
                toast.error("Error while saving data", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                setTimeout(() => {
                    window.location.reload(true);
                }, 3000);
            }
        }
    }
    const [rSelected, setRSelected] = useState(1);

    return (
        <div>
            <ToastContainer position="top-center" containerStyle={{ top: '50%' }} />
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Card className="my-4">
                <h2 className="card-header card-header-dark d-flex justify-content-between align-items-center">
                    Data Import
                </h2>
                <CardBody>
                    <Row>
                        <Col>
                            <label>A Vineyard record with matching ID must exist before a contact can be imported and associated with it.
                                Files should be imported in the following order when both files are imported in the same session:</label>
                                <br/>
                            <label>
                                1.	Vineyard 
                            </label>
                            <br />
                            <label>
                                2.	Contacts
                            </label>
                            <br />
                            <label>In case of errors, check that a Vineyard record with matching Vineyard ID exists for Vineyard(s) the Contact is associated with.</label>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                        <Col sm="3">
                            <ButtonGroup>
                                <Button
                                    color="primary"
                                    outline
                                    onClick={() => onSelectionChange(1)}
                                    active={rSelected === 1}
                                >
                                    Import Vineyard
                                </Button>
                                <Button
                                    color="primary"
                                    outline
                                    onClick={() => onSelectionChange(2)}
                                    active={rSelected === 2}
                                >
                                    Import Contact
                                </Button>
                            </ButtonGroup>
                        </Col>
                        <Col sm="6">
                            <Row >
                                <Col sm="4">
                                    <Row>
                                        <Col>
                                            {uploadDocumentNameVineyard != '' &&
                                                <>
                                                    <label style={{ float: "left" }} className="">{uploadDocumentNameVineyard}</label>
                                                </>
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            {vineYardFile != null ?
                                                <Button color="warning" style={{ float: "left" }} size="sm" onClick={handleBtnDocumentUploadClick} ><FaFile /> Modifiy File</Button> :
                                                <Button color="success" style={{ float: "left" }} size="sm" onClick={handleBtnDocumentUploadClick} ><FaFile /> Select File</Button>}
                                            <input style={{ display: 'none' }}
                                                ref={input => {
                                                    inputDocumentFile = input;
                                                }}
                                                className="fileInput" id="fileUpload" type="file" onChange={handleDocumentChange} />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col sm="8">
                                    {vineYardFile != null &&
                                        <>
                                            <br />
                                            {saving ?
                                                <Button onClick={handleUploadVineyard} color="success" disabled >
                                                    <Row>
                                                        <Col sm="9">
                                                            <span>
                                                                {' '}Uploading
                                                            </span>
                                                        </Col>
                                                        <Col sm="3">
                                                            <Spinner size="sm">
                                                                Uploading...
                                                            </Spinner>
                                                        </Col>
                                                    </Row>
                                                </Button>
                                                :
                                                <Button onClick={handleUploadVineyard} color="success" >
                                                    Upload
                                                </Button>
                                            }
                                        </>
                                    }
                                    {rSelected == 1 && <a href="/documents/Import_Vineyard_Template.csv" target="_blank" rel="noopener noreferrer" download>
                                        <Button style={{ backgroundColor: "#2b4c6e", borderColor: "#2b4c6e",marginLeft:"10px" }}>
                                            <FaDownload />
                                            &nbsp;Download Template File
                                        </Button>
                                    </a>}
                                    {rSelected == 2 && <a href="/documents/Import_Contact_Template.csv" target="_blank" rel="noopener noreferrer" download>
                                        <Button style={{ backgroundColor: "#2b4c6e", borderColor: "#2b4c6e", marginLeft: "10px" }}>
                                            <FaDownload />
                                            &nbsp;Download Template File
                                        </Button>
                                    </a>}
                                </Col>
                            </Row>
                            <Row>
                                <Col sm="12">
                                    {formDocumentErrors.DocumentName != undefined &&
                                        <>
                                            <label style={{ float: "left" }} className="errorMessage">{formDocumentErrors.DocumentName}</label>
                                        </>
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "10px" }}>
                        {rSelected == 1 && uploadedVineyardData.length > 0 &&
                            <>
                                <Col sm="12">
                                    <Row>
                                        <Col sm="6">
                                            <label style={{ fontSize:"18px" }}><b>Uploaded Vineyard details</b></label>
                                        </Col>
                                        <Col sm="6">
                                            {savingVineyard ?
                                            <Button style={{ float: "right" }} onClick={saveVineyardData} color="success" disabled >
                                                    <Row>
                                                        <Col sm="9">
                                                            <span>
                                                                {' '}Saving
                                                            </span>
                                                        </Col>
                                                        <Col sm="3">
                                                            <Spinner size="sm">
                                                                Saving...
                                                            </Spinner>
                                                        </Col>
                                                    </Row>
                                                </Button>
                                                :
                                            <Button style={{ float: "right" }} onClick={saveVineyardData} color="success" >
                                                    Save
                                                </Button>
                                            }
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: "10px" }}>
                                        <Col sm="12">
                                        <>
                                            <Table bordered className="Risktable" style={{ tableLayout: 'fixed', width: '100%' }}>
                                                <thead>
                                                    <tr style={{ background: '#a6b3a7' }}>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '10%', textAlign: 'left', color: "black" }}> Vineyard/Winery Number </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '9%', textAlign: 'left', color: "black" }}> Property Name </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '8%', textAlign: 'left', color: "black" }}> Region </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '8%', textAlign: 'left', color: "black" }}> Physical Address - Street 1 </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '8%', textAlign: 'left', color: "black" }}> Physical Address - Street 2 </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '8%', textAlign: 'left', color: "black" }}> Physical Address - Street 3 </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '8%', textAlign: 'left', color: "black" }}> Physical Address: City </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '8%', textAlign: 'left', color: "black" }}> Physical Address: Postcode </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '8%', textAlign: 'left', color: "black" }}> Physical Address: Country </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '8%', textAlign: 'left', color: "black" }}> Organisation Number (Parent Organisation) (Organisation)</th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '8%', textAlign: 'left', color: "black" }}> Parent Organisation </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '5%', textAlign: 'left', color: "black" }}> Status </th>
                                                    </tr>
                                                </thead>
                                                <tbody style={{ textAlign: 'center' }}>
                                                    <>
                                                        {uploadedVineyardData.length > 0 && uploadedVineyardData.map((item, pidx) =>
                                                            <>
                                                                {
                                                                    <>
                                                                        <tr>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.swnZ_Vineyard_ID} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.swnZ_Vineyard_Name} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.swnZ_Vineyard_Region} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.swnZ_Vineyard_Physical_Address_1} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.swnZ_Vineyard_Physical_Address_2} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.swnZ_Vineyard_Physical_Address_3} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.swnZ_Vineyard_Physical_Address_City} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.swnZ_Vineyard_Physical_Address_Postcode} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.swnZ_Vineyard_Physical_Address_Country} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.swnZ_Parent_Organisation_ID} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.swnZ_Parent_Organisation_Name} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.status} </td>
                                                                        </tr>
                                                                    </>
                                                                }
                                                            </>
                                                        )}
                                                    </>

                                                </tbody>
                                            </Table>
                                        </>
                                        </Col>
                                    </Row>

                                </Col>
                            </>}
                        {rSelected == 2 && uploadedContactData.length > 0 &&
                            <>
                                <Col sm="12">
                                    <Row>
                                        <Col sm="6">
                                            <label style={{ fontSize: "18px" }}><b>Uploaded Contact details</b></label>
                                        </Col>
                                    <Col sm="6">
                                        {savingContact ?
                                            <Button style={{ float: "right" }} onClick={saveContactData} color="success" disabled >
                                                    <Row>
                                                        <Col sm="9">
                                                            <span>
                                                                {' '}Saving
                                                            </span>
                                                        </Col>
                                                        <Col sm="3">
                                                            <Spinner size="sm">
                                                                Saving...
                                                            </Spinner>
                                                        </Col>
                                                    </Row>
                                                </Button>
                                                :
                                            <Button style={{ float: "right" }} onClick={saveContactData} color="success" >
                                                    Save
                                                </Button>
                                            }
                                        </Col>
                                    </Row>
                                    <Row style={{ marginTop: "10px" }}>
                                        <Col sm="12">
                                            <>
                                                <Table bordered className="Risktable" style={{ tableLayout: 'fixed', width: '100%' }}>
                                                    <thead>
                                                        <tr style={{ background: '#a6b3a7' }}>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '8%', textAlign: 'left', color: "black" }}> Auth0 Id  </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '6%', textAlign: 'left', color: "black" }}> First Name</th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '6%', textAlign: 'left', color: "black" }}> Last Name</th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '9%', textAlign: 'left', color: "black" }}> Address 2: Street 1 </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '9%', textAlign: 'left', color: "black" }}> Address 2: Street 2 </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '6%', textAlign: 'left', color: "black" }}> Address 2: City </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '6%', textAlign: 'left', color: "black" }}> Email  </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '6%', textAlign: 'left', color: "black" }}> Phone </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '6%', textAlign: 'left', color: "black" }}> Mobile Phone</th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '6%', textAlign: 'left', color: "black" }}> Role Type </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '6%', textAlign: 'left', color: "black" }}> Position </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '6%', textAlign: 'left', color: "black" }}> Vineyard/Winery Number </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '6%', textAlign: 'left', color: "black" }}> Property Name </th>
                                                        <th colSpan="1" rowSpan="1" style={{ width: '6%', textAlign: 'left', color: "black" }}> Status </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ textAlign: 'center' }}>
                                                    <>
                                                        {uploadedContactData.length > 0 && uploadedContactData.map((item, pidx) =>
                                                                <>
                                                                    {
                                                                        <>
                                                                            <tr>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.auth0_ID} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.first_Name} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.last_Name} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.address_1} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.address_2} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.city} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.email} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.phone} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.mobile_Phone} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.role} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.position} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.swnZ_Vineyard_ID} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.swnZ_Vineyard_Name} </td>
                                                                            <td style={{ wordBreak: "break-word", textAlign: "left", fontSize: "14px" }}> {item.status} </td>
                                                                            </tr>
                                                                        </>
                                                                    }
                                                                </>
                                                            )}
                                                        </>

                                                    </tbody>
                                                </Table>
                                            </>
                                        </Col>
                                    </Row>

                                </Col>
                            </>}
                    </Row>
                </CardBody>
            </Card>
            <Modal isOpen={showDeleteItemPopup}>
                <ModalHeader>Delete the item</ModalHeader>
                <ModalBody>
                    Do you want to delete the item ?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={confirmDeleteItemPopup}>Yes</Button>
                    <Button color="danger" onClick={closeDeleteItemPopup}>No</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default DataImport;
